<template>
  <div class="modal-box" @click="closeModal"></div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  prop: {

  },
  methods: {
    closeModal () {
      let closeModal = '1'
      this.$emit('closeModal', closeModal)
    }
  }
}
</script>

<style>
  .modal-box {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
  }
</style>
